var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,7.5c1.3,1.3,2,2.8,2.2,4.6c0.2,2.4-0.4,4.5-2.1,6.2c-1.2,1.2-1.7,2.6-1.7,4.3v0.2c0,0.5-0.2,0.7-0.7,0.7 h-6.8c-0.7,0-0.8-0.1-0.8-0.8c-0.1-0.8-0.2-1.5-0.3-2.3c-0.1-0.6-0.5-1.2-1-1.6c-1.1-1.1-1.9-2.4-2.3-3.9c-0.6-2.3-0.2-4.4,1.2-6.4 c1.2-1.7,2.8-2.8,4.8-3.2C17.2,4.6,19.7,5.4,21.8,7.5z M13.6,24.7c1.6,0,3.2,0,4.7,0c0.5,0,0.9,0.4,1,0.9c0.1,0.5-0.1,1-0.6,1.3 c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0.1h-5c-0.7-0.3-1-0.7-0.9-1.3C12.6,25.1,13.1,24.7,13.6,24.7z M16,15c-0.6,0-1,0.4-1,1v5 c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-5C17,15.4,16.6,15,16,15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjLight);
export default __webpack_public_path__ + "static/media/objLight.030f97fe24c1e34acc87855a461ec757.svg";
export { ForwardRef as ReactComponent };